import { AssessmentRepository } from 'application/repositories/AssessmentRepository';
import {
    AssessmentDetailResponse,
    AssessmentSimple,
    AssessmentSimpleResponse,
} from 'domain/entities/AssessmentEntity';
import { DataProperty, ParamsProperty } from 'domain/entities/PropertyEntity';

export class AssessmentUseCase implements AssessmentAPIUseCaseInterface {
    private assessmentRepo: AssessmentRepository;
    constructor(assessmentRepo: AssessmentRepository) {
        this.assessmentRepo = assessmentRepo;
    }

    async getAssessmentDetail(params: {
        listedPropertyId: number;
    }): Promise<AssessmentDetailResponse> {
        return await this.assessmentRepo.getAssessmentDetail(params);
    }
    async getListPropertyAssessment(params: ParamsProperty): Promise<DataProperty[]> {
        return await this.assessmentRepo.getListPropertyAssessment(params);
    }
    async putAssessmentSimpleData(params: AssessmentSimple): Promise<AssessmentSimpleResponse> {
        return await this.assessmentRepo.putAssessmentSimpleData(params);
    }
}
export interface AssessmentAPIUseCaseInterface {
    getAssessmentDetail(params: { listedPropertyId: number }): Promise<AssessmentDetailResponse>;
    getListPropertyAssessment(params: ParamsProperty): Promise<DataProperty[]>;
    putAssessmentSimpleData(params: AssessmentSimple): Promise<AssessmentSimpleResponse>;
}
